import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Hero from '../Elements/Hero';
import CredentialStrip from '../Elements/CredentialStrip';
import About from '../Elements/About';
import OurServices from '../Elements/OurServices';
import OurMission from '../Elements/OurMission';
import Capabilities from '../Elements/Capabilities';
import Contact from '../Elements/Contact';
import useReveal from '../../hooks/useReveal';
import usePageMeta from '../../hooks/usePageMeta';
import { company } from '../../content/site';

const Home = () => {
  useReveal();
  usePageMeta({
    title: 'LIDA Engineering | Construction & Engineering — Trinidad and Tobago, Guyana',
    description: company.metaDescription,
  });

  return (
    <>
      <Header overHero />
      <main id="main" className="page-content">
        <Hero />
        <CredentialStrip />
        <About />
        <OurServices />
        <Capabilities
          compact
          heading="The full scope of what we deliver."
          lead="From pre-project planning through to turnaround services, scaffolding and property maintenance."
        />
        <OurMission />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
